export const ar = {
  nav: {
    listings: "العقارات",
    map: "الخريطة",
    favorites: "المفضلة",
    messages: "الرسائل",
    publish: "نشر",
    login: "تسجيل الدخول",
    register: "إنشاء حساب",
    dashboard: "لوحة التحكم",
    logout: "تسجيل الخروج",
    tagline: "بلا حدود",
    subtitle: "السوق العقاري للمغرب الكبير",
  },
  home: {
    badge: "بلا حدود · المغرب الكبير",
    title_part1: "أكبر",
    title_part2: "سوق عقاري",
    title_part3: "في",
    title_highlight: "المغرب الكبير",
    description: "إعلانات موثقة من أفراد ووكالات محترفة في المغرب والجزائر وتونس. بحث متقدم، خريطة تفاعلية، واتصال مباشر.",
    cta_browse: "تصفح الإعلانات",
    cta_publish: "نشر إعلان",
    stat_listings: "إعلانات نشطة",
    stat_advertisers: "معلنون",
    stat_verified: "محترفون موثقون",
    stat_countries: "المغرب الكبير",
    featured_overline: "مختارات",
    featured_title: "إعلانات مميزة",
    country_all: "الكل",
    view_all: "عرض كل الإعلانات",
    pros_overline: "للوكالات",
    pros_title: "عزز ظهور وكالتك أمام آلاف المشترين.",
    pros_desc: "شارة \"محترف موثق\"، تعزيز الإعلانات، إحصائيات مفصلة، وإدارة مركزية. المنصة المخصصة للمحترفين العقاريين في المغرب الكبير.",
    pros_cta: "إنشاء حساب محترف",
  },
  search: {
    overline: "بحث",
    title: "إعلانات عقارية",
    placeholder_country: "الدولة",
    placeholder_type: "بيع / إيجار",
    placeholder_property_type: "نوع العقار",
    placeholder_city: "المدينة",
    placeholder_min_price: "أدنى سعر",
    placeholder_max_price: "أعلى سعر",
    placeholder_keyword: "كلمة مفتاحية (مسبح، إطلالة بحرية...)",
    placeholder_rooms: "أدنى عدد غرف",
    button_reset: "إعادة",
    button_search: "بحث",
    grid: "شبكة",
    map: "خريطة",
    results_count_one: "{{count}} إعلان",
    results_count_other: "{{count}} إعلانات",
    no_results: "لا توجد إعلانات مطابقة لمعاييرك.",
    countries: { all_long: "جميع الدول", all_short: "الكل", MA: "المغرب", DZ: "الجزائر", TN: "تونس" },
    types: { all: "بيع وإيجار", vente: "بيع", location: "إيجار" },
  },
  detail: {
    back: "العودة للنتائج",
    description: "الوصف",
    amenities: "المرافق",
    location: "الموقع",
    send_message: "إرسال الرسالة",
    sending: "جاري الإرسال...",
    add_to_favorites: "أضف للمفضلة",
    in_favorites: "موجود في المفضلة",
    badge_verified: "إعلان موثق",
    verified_text: "جميع المعلنين المحترفين موثقون يدوياً لضمان معاملات آمنة.",
  },
  auth: {
    login_title: "أهلاً بعودتك",
    login_subtitle: "ادخل إلى لوحة تحكم عقارات الخاصة بك.",
    register_title: "انضم إلى عقارات",
    register_subtitle: "انشر إعلاناتك في دقائق.",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    role: "نوع الحساب",
    role_particulier: "فرد",
    role_pro: "محترف / وكالة",
    company: "اسم الوكالة",
    country: "الدولة",
    submit_login: "تسجيل الدخول",
    submit_register: "إنشاء حسابي",
    or: "أو",
    google_continue: "المتابعة عبر Google",
    google_signup: "التسجيل عبر Google",
    no_account: "ليس لديك حساب؟",
    yes_account: "لديك حساب بالفعل؟",
    create: "إنشاء حساب",
  },
  dashboard: {
    overline: "لوحة التحكم",
    greeting: "مرحباً، {{name}}",
    pro: "محترف موثق",
    particulier: "حساب فرد",
    new_listing: "إعلان جديد",
    stats_total: "إعلانات",
    stats_active: "نشطة",
    stats_boosted: "مُعززة",
    stats_favorites: "إضافات للمفضلة",
    stats_messages: "رسائل",
    stats_views: "مشاهدات",
    stats_views_week: "(7أيام)",
    my_listings: "إعلاناتي",
    no_listings: "لا توجد إعلانات بعد.",
    create_first: "أنشئ أول إعلان",
    boost: "تعزيز",
    edit: "تعديل",
    delete: "حذف",
    boosted_label: "مُعززة",
    confirm_delete_title: "حذف هذا الإعلان؟",
    confirm_delete_desc: "هذا الإجراء نهائي. سيُحذف الإعلان من الموقع.",
    cancel: "إلغاء",
    become_pro_title: "كن محترفاً موثقاً",
    become_pro_desc: "شارة محترف، إعلانات بلا حدود، وتعزيز شهري ضمن الاشتراك.",
    become_pro_btn: "اشترك كمحترف",
    recommendation_low_views: "مشاهدات قليلة — تعزيز قد يرفع إعلانك بقوة",
    recommendation_low_conversion: "مشاهدات كثيرة لكن قليل من الاتصالات — حسّن الصور أو عزز",
    views_label: "مشاهدات",
    messages_label: "اتصالات",
    conversion_label: "تحويل",
  },
  favorites: {
    overline: "المفضلة",
    title: "العقارات المحفوظة",
    empty: "لا توجد عقارات في المفضلة بعد.",
  },
  messages: {
    overline: "الرسائل",
    title: "محادثاتي",
    empty: "لا توجد محادثات بعد.",
    select_thread: "اختر محادثة من القائمة",
    with: "مع",
    reply_placeholder: "ردك...",
  },
  language: {
    fr: "Français",
    ar: "العربية",
    en: "English",
  },
};
